export function redondearDos(numero){
    return Math.round(numero * 100) / 100
}

export function redondearDosString(numero){
    return (Math.round(numero * 100) / 100).toFixed(2);
}

export function propiedadesObjetoToArray(obj){
    return Object.entries(obj).map(( [k, v] ) => v);
}